var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrawerMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.846,
    height: 20,
    viewBox: "0 0 23.846 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_808",
    "data-name": "Path 808",
    d: "M22.846,13a2.006,2.006,0,0,1-2,2H5L1,19V3A2.006,2.006,0,0,1,3,1H20.846a2.006,2.006,0,0,1,2,2Z",
    fill: "none",
    stroke: "#b6b6c7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawerMessages);
export default __webpack_public_path__ + "static/media/drawer-messages.2b2d370590f1b9eca8d8644c6d6f7b7f.svg";
export { ForwardRef as ReactComponent };